
<div>
  <label class="label" :class="{ 'is-verified': !!verified[field.name] }">{{ label + (field.is_required ? ' *' : '') }}</label>
  <!-- <input type="checkbox" :checked="value.consented" :disabled="disabled || readonly || verified" @input="onToggle" /> -->
  <b-checkbox :checked="value.consented" :disabled="disabled || readonly || verified" @input="onToggle">
    {{ label }}
  </b-checkbox>
  <p v-if="description" class="help">{{ description }}</p>
</div>
